import {defineMessages} from "react-intl";

export default defineMessages({
    news: {id: "cli.news", defaultMessage: "News", description: 'news: News'},
})